import { createSlice } from "@reduxjs/toolkit";

const persistedDisplaySettings = (() => {
  try {
    const raw = localStorage.getItem("displaySettings");
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
})();

const initialState = {
  fontSize: "small", // small | medium | large
  charSpacing: "normal", // normal | wide | xwide
  isDarkMode: false,
  showParagraphNumbers: true,
  showQcPanel: true,
  ...(persistedDisplaySettings || {}),
};

const displaySettingsSlice = createSlice({
  name: "displaySettings",
  initialState,
  reducers: {
    setFontSize: (state, action) => {
      state.fontSize = action.payload;
    },
    setCharSpacing: (state, action) => {
      state.charSpacing = action.payload;
    },
    setDarkMode: (state, action) => {
      state.isDarkMode = action.payload;
    },
    toggleDarkMode: (state) => {
      state.isDarkMode = !state.isDarkMode;
    },
    setShowParagraphNumbers: (state, action) => {
      state.showParagraphNumbers = action.payload;
    },
    toggleParagraphNumbers: (state) => {
      state.showParagraphNumbers = !state.showParagraphNumbers;
    },
    setShowQcPanel: (state, action) => {
      state.showQcPanel = action.payload;
    },
    toggleQcPanel: (state) => {
      state.showQcPanel = !state.showQcPanel;
    },
  },
});

export const {
  setFontSize,
  setCharSpacing,
  setDarkMode,
  toggleDarkMode,
  setShowParagraphNumbers,
  toggleParagraphNumbers,
  setShowQcPanel,
  toggleQcPanel,
} = displaySettingsSlice.actions;

export const selectFontSizeSetting = (state) => state.displaySettings.fontSize;
export const selectCharSpacingSetting = (state) =>
  state.displaySettings.charSpacing;
export const selectDarkMode = (state) => state.displaySettings.isDarkMode;
export const selectShowParagraphNumbers = (state) =>
  state.displaySettings.showParagraphNumbers;
export const selectShowQcPanel = (state) => state.displaySettings.showQcPanel;

export default displaySettingsSlice.reducer;
